<template>
  <neon-main>
    <div class="index-main">
      <router-view></router-view>
      <p>
        <router-link to="/aboutUs">About</router-link>&nbsp;&nbsp;
        <router-link to="/contactUs">Contact Us</router-link>&nbsp;&nbsp;
        <router-link to="/online">Online</router-link>&nbsp;&nbsp;
        <router-link to="/http">Http Demo</router-link>
      </p>
    </div>
  </neon-main>
</template>

<script>
  import Main from '../common/Main.vue'

  export default {
    name: 'about',
    components: {

      'neon-main': Main
    }
  }
</script>

<style scoped>
  .index-main{
    margin: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/modules/about/about.vue